import script from "./stdOnboardingSixthPage.vue?vue&type=script&setup=true&lang=js"
export * from "./stdOnboardingSixthPage.vue?vue&type=script&setup=true&lang=js"

import "./stdOnboardingSixthPage.vue?vue&type=style&index=0&id=011c404e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-011c404e"]])

export default __exports__